import React from 'react';
import type { JSX } from 'react';
import { Role } from '../../api/llmapi';
import ChatMessage from './chatmessage';
import ChatInput from './chatinput';
import SysPrompt from './sysprompt';
import { Conversation } from '../../../fasades/conversation';
import { Message } from '../../chat/message';
import { Key } from './key';
import './chatcomponent.css';

export enum Mode {
    Desktop,
    Mobile
};

interface ChatState
{
    messages : Message[];
}

interface ChatProps
{
    showPrompt? : boolean;
    mode        : Mode;
}

export class ChatComponent extends React.Component<ChatProps, ChatState> {
    private messagesEndRef : React.RefObject<HTMLDivElement|null>;

    constructor(props: ChatProps) {
        super(props);
        this.state = {
          messages : Conversation.getMessages()
        };

        this.messagesEndRef = React.createRef<HTMLDivElement>();
    }

    componentDidMount()
    {
        Conversation.onUpdate(this.handleUpdate.bind(this));
    }

    componentDidUpdate(prevProps: ChatProps) {
        if (this.state.messages.length > 0)
            this.scrollToBottom();
    }

    componentWillUnmount()
    {
        Conversation.removeUpdateEvent(this.handleUpdate.bind(this));
    }

    handleUpdate()
    {
        this.setState({messages : Conversation.getMessages()});
    }

    render() {
        const messages = this.state.messages;
        const chatMessages : JSX.Element[] = [];
        let   key = new Key();
        for (let i = 0; i < messages.length; i++) {
            const message = messages[i];
            if (message.role !== Role.System) {
                chatMessages.push(
                    <ChatMessage key={key.get()} message={message} />
                );
            }
        }

        return (
            <div className="chat-container">
                <div className="messages-container" ref={this.messagesEndRef}>
                    { this.props.showPrompt && <SysPrompt show={true} /> }

                    {messages.length === 0 ? (
                        <div className="empty-chat">
                            <p>Start a conversation with the chatbot!</p>
                        </div>
                      ) : (
                        <>{chatMessages}</>
                    )}
                </div>
                <ChatInput/>
            </div>
        );
    }

    scrollToBottom() 
    {
        const el = this.messagesEndRef.current;
        el!.scrollTop = el!.scrollHeight;
    };
}

